module.exports = __webpack_public_path__ + "assets/img/suggest.5d14d185.svg";